/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconListCheck = createReactComponent("outline", "list-check", "IconListCheck", [["path", { "d": "M3.5 5.5l1.5 1.5l2.5 -2.5", "key": "svg-0" }], ["path", { "d": "M3.5 11.5l1.5 1.5l2.5 -2.5", "key": "svg-1" }], ["path", { "d": "M3.5 17.5l1.5 1.5l2.5 -2.5", "key": "svg-2" }], ["path", { "d": "M11 6l9 0", "key": "svg-3" }], ["path", { "d": "M11 12l9 0", "key": "svg-4" }], ["path", { "d": "M11 18l9 0", "key": "svg-5" }]]);

export { IconListCheck as default };
//# sourceMappingURL=IconListCheck.mjs.map
